import { render, staticRenderFns } from "./LearningSituation.vue?vue&type=template&id=8d88c560&scoped=true"
import script from "./LearningSituation.vue?vue&type=script&lang=js"
export * from "./LearningSituation.vue?vue&type=script&lang=js"
import style0 from "./LearningSituation.vue?vue&type=style&index=0&id=8d88c560&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d88c560",
  null
  
)

export default component.exports